import { ProductActionTypes } from '../../../enums/ActionEnums';
export const productActions = {
    createInitAction: (payload) => ({
        type: ProductActionTypes.INIT,
        payload,
    }),
    createSelectSizeAction: (payload) => ({
        type: ProductActionTypes.SELECT_SIZE,
        payload,
    }),
    createSetEsiDataAction: (payload) => ({
        type: ProductActionTypes.SET_ESI_DATA,
        payload,
    }),
    createSetColorAction: (payload) => ({
        type: ProductActionTypes.SET_COLOR,
        payload,
    }),
    createSetSizeCombinationNotExistAction: (payload) => ({
        type: ProductActionTypes.SET_SIZE_COMBINATION_NOT_EXIST,
        payload,
    }),
    createGetDeliveryPromise: () => ({
        type: ProductActionTypes.GET_DELIVERY_PROMISE,
    }),
    createGetDeliveryPromiseExtended: (payload) => ({
        type: ProductActionTypes.GET_DELIVERY_PROMISE_EXTENDED,
        payload,
    }),
    createSetDeliveryPromiseExtended: (payload) => ({
        type: ProductActionTypes.SET_DELIVERY_PROMISE_EXTENDED,
        payload,
    }),
    createSetDeliveryPromise: (payload) => ({
        type: ProductActionTypes.SET_DELIVERY_PROMISE,
        payload,
    }),
    createSetNewProduct: (payload) => ({
        type: ProductActionTypes.SET_NEW_PRODUCT,
        payload,
    }),
    createLoadProductData: (productCode) => ({
        type: ProductActionTypes.LOAD_PRODUCT_DATA,
        payload: { data: { productCode } },
    }),
    createClearProductData: () => ({
        type: ProductActionTypes.CLEAR_PRODUCT_DATA,
    }),
    createSetSelectedProductTab: (payload) => ({
        type: ProductActionTypes.SET_SELECTED_PRODUCT_TAB,
        payload,
    }),
    setProductVideos: (payload) => ({
        type: ProductActionTypes.SET_PRODUCT_VIDEOS,
        payload,
    }),
    setProductContentVideos: (payload) => ({
        type: ProductActionTypes.SET_PRODUCT_CONTENT_VIDEOS,
        payload,
    }),
    createGetTechnicalCategories: (payload) => ({
        type: ProductActionTypes.GET_TECHNICAL_CATEGORIES,
        payload,
    }),
    createSetTechnicalCategories: (payload) => ({
        type: ProductActionTypes.SET_TECHNICAL_CATEGORIES,
        payload,
    }),
    createGetLinkedProducts: (payload) => ({
        type: ProductActionTypes.GET_LINKED_PRODUCTS,
        payload,
    }),
    createSetLinkedProducts: (payload) => ({
        type: ProductActionTypes.SET_LINKED_PRODUCTS,
        payload,
    }),
    getProductCareDeliveryPromise: (payload) => ({
        type: ProductActionTypes.GET_PRODUCT_CARE_DELIVERY_PROMISE,
        payload,
    }),
    setProductCareDeliveryPromise: (payload) => ({
        type: ProductActionTypes.SET_PRODUCT_CARE_DELIVERY_PROMISE,
        payload,
    }),
    sizeGuideOpen: () => ({
        type: ProductActionTypes.SIZE_GUIDE_OPEN,
    }),
    getBundle: (monetateId) => ({
        type: ProductActionTypes.GET_BUNDLE,
        payload: monetateId,
    }),
    setBundle: (payload) => ({
        type: ProductActionTypes.SET_BUNDLE,
        payload,
    }),
    bundleSetSelectedSlotState: (payload) => ({
        type: ProductActionTypes.BUNDLE_SET_SELECTED_SLOT_STATE,
        payload,
    }),
    bundleSetDisplayedProduct: (payload) => ({
        type: ProductActionTypes.BUNDLE_SET_DISPLAYED_PRODUCT,
        payload,
    }),
    bundleCalculateStart: () => ({
        type: ProductActionTypes.BUNDLE_CALCULATE_START,
    }),
    bundleCalculateSuccess: (payload) => ({
        type: ProductActionTypes.BUNDLE_CALCULATE_SUCCESS,
        payload,
    }),
    bundleCalculateFailure: (payload) => ({
        type: ProductActionTypes.BUNDLE_CALCULATE_FAILURE,
        payload,
    }),
    bundleSetSelectedAlternativeTab: (payload) => ({
        type: ProductActionTypes.SET_SELECTED_BUNDLE_TAB,
        payload,
    }),
    fetchAlternatives: (payload) => ({
        type: ProductActionTypes.FETCH_ALTERNATIVES,
        payload,
    }),
    setAlternatives: (payload) => ({
        type: ProductActionTypes.SET_ALTERNATIVES,
        payload,
    }),
    setAlternativesCampaign: (payload) => ({
        type: ProductActionTypes.SET_ALTERNATIVES_CAMPAIGN,
        payload,
    }),
    setNotifyMeError: (payload) => ({
        type: ProductActionTypes.SET_NOTIFY_ME_ERROR,
        payload,
    }),
};
